import AxiosInstance from "../services/networkServices";

// Dance API endpoints
// Backend mounts routes at both /dance and /admin/dance
// Using /admin/dance for admin operations

export const createDance = async (payload) => {
  const res = await AxiosInstance.post("/admin/dance/create", payload);
  return res.data;
};

export const updateDance = async (payload, id) => {
  const res = await AxiosInstance.patch(`/admin/dance/update/${id}`, payload);
  return res.data;
};

export const listDance = async ({ limit = 20, nextId, searchBy, page, sortBy, sortOrder, status } = {}) => {
  const params = {};
  if (limit) params.limit = limit;
  if (nextId) params.nextId = nextId;
  if (searchBy) params.searchBy = searchBy;
  // Page mode: numbered pages with a total count (admin tables)
  if (page) params.page = page;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  if (status) params.status = status;
  const res = await AxiosInstance.get("/dance/list", { params });
  return res.data;
};

// Scheduled + active tracks in the order mobile users see them
export const getDanceOrder = async () => {
  const res = await AxiosInstance.get("/admin/dance/order");
  return res.data;
};

export const updateDanceOrder = async (ids) => {
  const res = await AxiosInstance.put("/admin/dance/order", { ids });
  return res.data;
};

export const viewDance = async (id) => {
  const res = await AxiosInstance.get(`/dance/view/${id}`);
  return res.data;
};

export const deleteDance = async (id) => {
  const res = await AxiosInstance.delete(`/admin/dance/delete/${id}`);
  return res.data;
};
